export function deletar(fetch, id) {
  return fetch().delete("/setor/" + id);
}

export function getAll(fetch) {
  return fetch().get("/setor");
}

export function getDetalhe(fetch, id) {
  return fetch().get("/setor/" + id);
}

export function post(fetch, loja) {
  return fetch().post("/setor", loja);
}
